// extracted by mini-css-extract-plugin
export default {"checkbox":"MeasureItem_checkbox__5oLti","container":"MeasureItem_container__ElO+h"};